import React, { useRef } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from "recharts";
import html2canvas from "html2canvas";

interface BarChartOneDayProps {
  chartName: string;
  days: {
    day_0: boolean;
    day_1: boolean;
    day_2: boolean;
    day_3: boolean;
    day_4: boolean;
    day_5: boolean;
    day_6: boolean;
  };
  data: {
    name: string;
    value_day_0?: number;
    value_day_1?: number;
    value_day_2?: number;
    value_day_3?: number;
    value_day_4?: number;
    value_day_5?: number;
    value_day_6?: number;
  }[];
}

const BarChartOneDayComponent: React.FC<BarChartOneDayProps> = ({
  chartName,
  data,
  days,
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null);

  const saveChartAsImage = async () => {
    if (!chartRef.current) return;

    const element = chartRef.current;

    const canvas = await html2canvas(element, {
      scrollX: 0,
      scrollY: 0,
      width: element.scrollWidth,
      height: element.scrollHeight,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
      scale: 2, // ให้ภาพคมขึ้น
    });

    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png");
    link.download = "bar-chart.png";
    link.click();
  };

  return (
    <div className="p-2 lg:p-5 flex flex-col w-full">
      <div className="bg-white p-4 rounded-lg shadow-lg">
        <h2 className="font-semibold text-center mb-2">{chartName}</h2>

        <div className="overflow-x-auto no-scrollbar">
          <div
            ref={chartRef}
            className="min-w-[900px] w-full lg:w-full h-[200px] text-xs"
          >
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                {days.day_0 && (
                  <Bar dataKey="value_day_0" fill="#FF6384" name="Sunday" />
                )}
                {days.day_1 && (
                  <Bar dataKey="value_day_1" fill="#FFCE56" name="Monday" />
                )}
                {days.day_2 && (
                  <Bar dataKey="value_day_2" fill="#FF69B4" name="Tuesday" />
                )}
                {days.day_3 && (
                  <Bar dataKey="value_day_3" fill="#4EA72E" name="Wednesday" />
                )}
                {days.day_4 && (
                  <Bar dataKey="value_day_4" fill="#FF9F40" name="Thursday" />
                )}
                {days.day_5 && (
                  <Bar dataKey="value_day_5" fill="#36A2EB" name="Friday" />
                )}
                {days.day_6 && (
                  <Bar dataKey="value_day_6" fill="#9966FF" name="Saturday" />
                )}
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      <div className="flex items-start w-full">
        <button
          onClick={saveChartAsImage}
          className="mt-4 bg-green text-sm text-white px-4 py-2 rounded-lg shadow-md hover:bg-green/50"
        >
          Download Image
        </button>
      </div>
    </div>
  );
};

export default BarChartOneDayComponent;
